import React from 'react';
import { VIDEO_SELFIE } from 'constants/identityMethod';
import {
    BLOCKED,
    CALLCENTER_KO,
    CAMERA_ERROR,
    LEAVE,
    WRONG_FACE_MATCH,
    WRONG_PERMISSIONS,
} from 'constants/video/status';
import { BlockedModal, MessageModal, PermissionsModal } from 'components/newIdentifyMethods/videoModals';
import { WrongFaceMatchModalContent } from 'components/newIdentifyMethods/videoModals/WrongFaceMatchModal';
import { formatText } from 'core/i18n';
import { getTextMessageByVideoStatusCode } from 'utilities/video/getTextMessageByStatusCode';

export const VideoScreenModalBody = ({
    statusCode,
    userProfile,
    statusNumber,
    documentType,
    identityType,
    leaveModalTag,
    handlePrevious,
    handleRetry,
    handleModal,
}) => {
    const isVideoSelfie = identityType === VIDEO_SELFIE;

    if (statusCode === BLOCKED) return <BlockedModal userProfile={userProfile} onAccept={handlePrevious} />;
    if (statusCode === WRONG_PERMISSIONS) return <PermissionsModal onAccept={() => handleModal(false)} />;
    if (statusCode === WRONG_FACE_MATCH)
        return (
            <WrongFaceMatchModalContent
                onFinish={handlePrevious}
                statusNumber={statusNumber}
                statusCode={statusCode}
                videoType={identityType}
            />
        );
    if (statusCode === LEAVE) {
        const videoLeaveTitleMSG = isVideoSelfie ? 'identity-videoSelfieLeaveTitle' : 'identity-videoCallLeaveTitle';
        const leaveModalAccept = () => {
            leaveModalTag('continuar');
            handleModal(false);
        };

        const leaveModalCancel = () => {
            leaveModalTag('abandonar');
            handlePrevious();
        };

        return (
            <MessageModal
                title={formatText(videoLeaveTitleMSG, [userProfile.name])}
                message={formatText('identity-videoCallLeaveConfirmation')}
                onAccept={leaveModalAccept}
                onCancel={leaveModalCancel}
                statusNumber={statusNumber}
                statusCode={statusCode}
                videoType={identityType}
                showImage={false}
                showsSecondaryButton
            />
        );
    }

    const message = getTextMessageByVideoStatusCode({ isVideoSelfie, documentType, statusCode });
    const showModalImage = statusCode !== CALLCENTER_KO;

    const handleModalAccept = statusCode === CAMERA_ERROR ? handleRetry : handlePrevious;

    return (
        <MessageModal
            title={formatText('identity-videoCallErrorTitle')}
            message={formatText(message)}
            onAccept={handleModalAccept}
            statusNumber={statusNumber}
            statusCode={statusCode}
            videoType={identityType}
            showImage={showModalImage}
        />
    );
};
